import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#fixLegacyShareLinks();
    this.#warnNewWindowLinks();
  }

  /**
   * WordPress-migrated share buttons use onclick window.open popup.
   * Remove JS new-window behavior; rely on target="_blank" + aria-describedby (F22).
   */
  #fixLegacyShareLinks() {
    for (const link of this.querySelectorAll('a[onclick*="window.open"]')) {
      link.removeAttribute('onclick');
      link.setAttribute('target', '_blank');

      const rel = link.getAttribute('rel') ?? '';
      if (!/\bnoopener\b/.test(rel)) {
        link.setAttribute('rel', rel ? `${rel} noopener noreferrer`.trim() : 'noopener noreferrer');
      }
    }
  }

  /**
   * WCAG 3.2.5 / F22: warn when a link opens a new window.
   * Prefer aria-describedby over aria-label so the visible link text stays the name.
   */
  #warnNewWindowLinks() {
    const newWindowMessageId = 'a11y-new-window-message';
    if (!document.getElementById(newWindowMessageId)) return;

    for (const link of this.querySelectorAll('a[target="_blank"]')) {
      const describedBy = link.getAttribute('aria-describedby') ?? '';
      const ids = describedBy.split(/\s+/).filter(Boolean);

      if (ids.includes(newWindowMessageId)) continue;

      ids.push(newWindowMessageId);
      link.setAttribute('aria-describedby', ids.join(' '));
    }
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
